import axios from "axios";
export default {
  upload(file) {
    const fmData = new FormData();
    fmData.append("file", file);
    return axios.post("c-file", fmData);
  },
};
